"use client";

import React, { useEffect, useRef, useState } from "react";
import { Activity, Bone, Droplet, Eye, Footprints, Pill, Scissors, Sparkles, Stethoscope } from "lucide-react";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const specialties = [{
  title: "Orthopedics",
  icon: Bone
}, {
  title: "Spine Surgery",
  icon: Activity
}, {
  title: "Pain Management",
  icon: Pill
}, {
  title: "General Surgery",
  icon: Scissors
}, {
  title: "Ophthalmology",
  icon: Eye
}, {
  title: "Gastroenterology",
  icon: Stethoscope
}, {
  title: "Podiatry",
  icon: Footprints
}, {
  title: "Plastic Surgery",
  icon: Sparkles
}, {
  title: "Urology",
  icon: Droplet
}];
export default function SpecialtiesSupported() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}